/**
 * Wizard URL / deep-link helpers
 * Extends window.WorkshopBookingWizardHelpers (defer after helpers.js).
 */
(function (global) {
  'use strict';
  var H = global.WorkshopBookingWizardHelpers;
  if (!H) return;

  var extractNumericEventIdForUrl = H.extractNumericEventIdForUrl;
  var extractNumericVariantIdForUrl = H.extractNumericVariantIdForUrl;
  var extractNumericVenueRefForUrl = H.extractNumericVenueRefForUrl;
  var vQtyKey = H.vQtyKey;
  var venueNamesLooselyMatch = H.venueNamesLooselyMatch;
  var venueRefAliasKeys = H.venueRefAliasKeys;
  var venueTokenMatchesCitySlug =
    typeof H.venueTokenMatchesCitySlug === 'function' ? H.venueTokenMatchesCitySlug : function () {
      return false;
    };

  function readInitialVariantIdFromUrl() {
    if (window.__WB_INITIAL_VARIANT__ != null && String(window.__WB_INITIAL_VARIANT__).trim() !== '') {
      return vQtyKey(window.__WB_INITIAL_VARIANT__);
    }
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      return v && String(v).trim() ? vQtyKey(v) : '';
    } catch (_) {
      return '';
    }
  }

  function getEventIdFromUrl() {
    if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') {
      return String(window.__WB_INITIAL_EVENT_ID__).trim();
    }
    try {
      return (new URLSearchParams(window.location.search).get('event_id') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function getVenueTokenFromUrl() {
    try {
      return (new URLSearchParams(window.location.search).get('venue') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function getStateCodeFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = (params.get('state') || params.get('state_code') || '').trim();
      if (/^[a-z]{2}$/i.test(raw)) return raw.toUpperCase();
      return '';
    } catch (_) {
      return '';
    }
  }

  function regionNameToCodeMap() {
    try {
      if (global.WorkshopBookingUtils && global.WorkshopBookingUtils.CATALOG_REGION_NAME_TO_CODE) {
        return global.WorkshopBookingUtils.CATALOG_REGION_NAME_TO_CODE;
      }
    } catch (_) {}
    return {};
  }

  function regionCodeFromName(name) {
    var raw = String(name || '').trim();
    if (!raw) return '';
    if (/^[a-z]{2}$/i.test(raw)) return raw.toUpperCase();
    var map = regionNameToCodeMap();
    var fromMap = map[raw.toLowerCase()];
    return fromMap ? String(fromMap).toUpperCase() : '';
  }

  function regionCodeFromAddress(addr) {
    var m = String(addr || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
    return m ? m[1].toUpperCase() : '';
  }

  function venueRegionCode(venue) {
    if (!venue || typeof venue !== 'object') return '';
    var direct = [venue.region_code, venue.state_code];
    for (var i = 0; i < direct.length; i++) {
      var d = String(direct[i] || '').trim();
      if (/^[a-z]{2}$/i.test(d)) return d.toUpperCase();
    }
    var ck = String(venue.city_key || '').trim().toLowerCase();
    var m = ck.match(/^us-([a-z]{2})-/);
    if (m) return m[1].toUpperCase();
    var fromName = regionCodeFromName(venue.region_name || venue.state);
    if (fromName) return fromName;
    return regionCodeFromAddress(venue.venue_address || venue.address || '');
  }

  function catalogRowRegionCode(row) {
    if (!row || typeof row !== 'object') return '';
    var code = String(row.region_code || row.state_code || '').trim();
    if (/^[a-z]{2}$/i.test(code)) return code.toUpperCase();
    var fromName = regionCodeFromName(row.region_name);
    if (fromName) return fromName;
    return regionCodeFromAddress(row.venue_address || row.address || '');
  }

  /**
   * @param {object} venueOrRow
   * @param {string} stateCode
   * @param {{ requireState?: boolean, fromCatalog?: boolean }} opts
   * requireState: missing region fails; otherwise missing region is allowed.
   */
  function venueRegionMatchesState(venueOrRow, stateCode, opts) {
    opts = opts || {};
    var want = String(stateCode || '')
      .trim()
      .toUpperCase();
    if (!want) return true;
    var code = opts.fromCatalog ? catalogRowRegionCode(venueOrRow) : venueRegionCode(venueOrRow);
    if (!code) return !opts.requireState;
    return code === want;
  }

  function urlHasWizardDeepLink() {
    return !!(getVenueTokenFromUrl() || getEventIdFromUrl());
  }

  function venueCardIsWaitlistOnly(card) {
    if (!card) return false;
    if (card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    return !!(card._wbVenue && card._wbVenue._wbWaitlistVenue === true);
  }

  function getWbwStepFromUrl() {
    try {
      return (new URLSearchParams(window.location.search).get('wbw_step') || '').trim().toLowerCase();
    } catch (_) {
      return '';
    }
  }

  function clearWbwStepFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('wbw_step')) return;
      params.delete('wbw_step');
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }

  function isVenueHandleToken(val) {
    var s = String(val == null ? '' : val).trim();
    return s.length > 0 && !/^\d+$/.test(s);
  }

  function venueUrlToken(venue) {
    if (!venue) return '';
    var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
    if (ref) return ref;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      if (!evs[i]) continue;
      ref = extractNumericVenueRefForUrl(evs[i].venue_ref_id);
      if (ref) return ref;
    }
    var h = String(venue.venue_handle || venue.handle || '').trim();
    if (h) return h;
    for (var j = 0; j < evs.length; j++) {
      if (!evs[j]) continue;
      h = String(evs[j].venue_handle || '').trim();
      if (h) return h;
    }
    return '';
  }

  function venueHandleFromSlotRaw(raw) {
    if (!raw) return '';
    var ref = extractNumericVenueRefForUrl(raw.venue_ref_id);
    if (ref) return ref;
    var h = String(raw.venue_handle || '').trim();
    return h || '';
  }

  function venueMatchesUrlToken(venue, token, opts) {
    opts = opts || {};
    token = String(token || '').trim().toLowerCase();
    if (!token || !venue) return false;
    var matched = false;
    if (String(venue.venue_handle || venue.handle || '').trim().toLowerCase() === token) matched = true;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    if (!matched) {
      for (var i = 0; i < evs.length; i++) {
        if (String((evs[i] && evs[i].venue_handle) || '').trim().toLowerCase() === token) {
          matched = true;
          break;
        }
      }
    }
    if (!matched) {
      var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
      if (ref && ref.toLowerCase() === token) matched = true;
    }
    if (!matched) {
      var nameFields = [venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < nameFields.length; ni++) {
        var n = String(nameFields[ni] || '').trim().toLowerCase();
        if (!n) continue;
        if (n === token || venueNamesLooselyMatch(n, token) || venueTokenMatchesCitySlug(n, token)) {
          matched = true;
          break;
        }
      }
    }
    if (!matched) {
      var handleFields = [venue.venue_handle, venue.handle];
      for (var hi = 0; hi < handleFields.length; hi++) {
        if (venueTokenMatchesCitySlug(handleFields[hi], token)) {
          matched = true;
          break;
        }
      }
    }
    if (!matched) {
      venueRefAliasKeys(venue.venue_ref_id).forEach(function (k) {
        if (String(k).trim().toLowerCase() === token) matched = true;
      });
    }
    if (!matched) return false;
    if (/^\d+$/.test(token)) return true;
    var stateCode = opts.stateCode || '';
    if (!stateCode) return true;
    return venueRegionMatchesState(venue, stateCode, {
      requireState: !!opts.requireState,
      fromCatalog: !!opts.fromCatalog,
    });
  }

  function updateWizardBookingUrl(patch) {
    if (!patch) return;
    try {
      var params = new URLSearchParams(window.location.search);
      if (Object.prototype.hasOwnProperty.call(patch, 'eventId')) {
        var eid = extractNumericEventIdForUrl(patch.eventId);
        if (eid) {
          window.__WB_STRIP_EVENT_ID_PARAM__ = false;
          params.set('event_id', eid);
          window.__WB_URL_EVENT_ID_NUMERIC__ = eid;
        } else {
          window.__WB_STRIP_EVENT_ID_PARAM__ = true;
          window.__WB_URL_EVENT_ID_NUMERIC__ = '';
          window.__WB_INITIAL_EVENT_ID__ = null;
          params.delete('event_id');
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'variantId')) {
        var vid = extractNumericVariantIdForUrl(patch.variantId);
        if (vid) {
          params.set('variant', vid);
          window.__WB_URL_VARIANT_NUMERIC__ = vid;
        } else {
          params.delete('variant');
          window.__WB_URL_VARIANT_NUMERIC__ = '';
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'venue')) {
        var vt = String(patch.venue == null ? '' : patch.venue).trim();
        if (vt) {
          window.__WB_STRIP_VENUE_PARAM__ = false;
          params.set('venue', vt);
          if (Object.prototype.hasOwnProperty.call(patch, 'state')) {
            var stCode = String(patch.state || '')
              .trim()
              .toUpperCase();
            if (/^[A-Z]{2}$/.test(stCode)) {
              params.set('state', stCode);
              params.delete('state_code');
            } else {
              params.delete('state');
              params.delete('state_code');
            }
          } else if (/^\d+$/.test(vt)) {
            /* Numeric venue id is unique — drop city/state filter so share URLs stay precise. */
            params.delete('state');
            params.delete('state_code');
          }
        } else {
          window.__WB_STRIP_VENUE_PARAM__ = true;
          params.delete('venue');
          params.delete('state');
          params.delete('state_code');
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'step')) {
        var st = String(patch.step || '').trim().toLowerCase();
        if (st === 'datetime' || st === 'variants') params.set('wbw_step', st);
        else params.delete('wbw_step');
      }
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }
  H.clearWbwStepFromUrl = clearWbwStepFromUrl;
  H.getEventIdFromUrl = getEventIdFromUrl;
  H.getStateCodeFromUrl = getStateCodeFromUrl;
  H.getVenueTokenFromUrl = getVenueTokenFromUrl;
  H.getWbwStepFromUrl = getWbwStepFromUrl;
  H.isVenueHandleToken = isVenueHandleToken;
  H.readInitialVariantIdFromUrl = readInitialVariantIdFromUrl;
  H.updateWizardBookingUrl = updateWizardBookingUrl;
  H.urlHasWizardDeepLink = urlHasWizardDeepLink;
  H.venueCardIsWaitlistOnly = venueCardIsWaitlistOnly;
  H.venueHandleFromSlotRaw = venueHandleFromSlotRaw;
  H.venueMatchesUrlToken = venueMatchesUrlToken;
  H.venueRegionCode = venueRegionCode;
  H.venueRegionMatchesState = venueRegionMatchesState;
  H.catalogRowRegionCode = catalogRowRegionCode;
  H.venueUrlToken = venueUrlToken;
})(typeof window !== "undefined" ? window : this);
